module.exports = "/packs/images/homepage/activity/extreme_mobile~99c0d1754a465d40080a50807ba7dc57.jpg";